<template>
    <div class="container analytics-dashboard">
        <h2 data-qa="analytics-heading">
            Analytics
        </h2>

        <h4 class="analytics-subhead" data-qa="analytics-subhead">
            Dashboards
        </h4>

        <div style="display: grid; grid-row-gap: 1rem; grid-column-gap: 1rem; grid-template-columns: repeat(3, 1fr);padding-top: 10px;">
            <ds-card
                v-for="(item, index) in analyticsData"
                :key="index"
                elevation="z4"
                data-qa="display-analytics-data"
            >
                <ds-card-header data-qa="analytic-title">
                    <ds-list-item border-style="none">
                        <template #leading>
                            <ds-icon :name="item.name" />
                        </template>

                        <template #title>
                            <h3 class="analytic-title">
                                {{ item.title }}
                            </h3>
                        </template>
                    </ds-list-item>
                </ds-card-header>

                <ds-card-body>
                    <div class="description-font">
                        Description
                    </div>

                    <p data-qa="analytic-description">
                        {{ item.description }}
                    </p>

                    <div class="link-icon">
                        <ds-link :href="item.url" data-qa="analytic-icon">
                            <template #leading>
                                <ds-icon name="arrow-long-right" />
                            </template>
                        </ds-link>
                    </div>
                </ds-card-body>
            </ds-card>
        </div>
    </div>
</template>

<script>
export default {
    props: {
    },

    data() {
        return {
            analyticsData: [
                {
                    id: 1,
                    name: 'activity',
                    title: 'Overview',
                    description: 'Get a glimpse of the most important data from each area of your business.',
                    url: '/Reports/analyticsReport.jsp?report=18',
                },
                {
                    id: 2,
                    name: 'contact-add-user-plus',
                    title: 'Contact growth',
                    description: 'See how your contact growth is performing right now, and how it’s tracking over time.',
                    url: '/Reports/analyticsReport.jsp?report=13',
                },
                {
                    id: 3,
                    name: 'email-open',
                    title: 'Email deliverability',
                    description: 'See the impact of your email efforts, from activity to status to performance.',
                    url: '/Reports/analyticsReport.jsp?report=14',
                },
                {
                    id: 4,
                    name: 'sales',
                    title: 'Payments, revenue, and refunds',
                    description: 'Track the financial impact that payments, refunds, and revenue is having on the health of your business.',
                    url: '/Reports/analyticsReport.jsp?report=15',
                },
            ],
        };
    },

    methods: {
    },
};
</script>

<style lang="scss" scoped>
.analytics-dashboard {
    .list-item {
        padding-bottom: 0;
    }

    .list-item > .leading-slot {
        padding: 0;
    }

    .description-font {
        font-size: $font-size-xs;
        color: $color-gray-800;
        margin-bottom: $spacing-100;
    }

    .link-icon {
        display: flex;
        justify-content: end;
        color: $color-gray-800;
    }

    .ds-card {
        width: 19.5rem;
        margin-bottom: 0;
    }

    .analytic-title {
        overflow: hidden;
        text-overflow: ellipsis;
        display: block;
        width: 100%;
        line-height: 1.6;
    }

    .analytics-subhead {
        padding-top: $spacing-400;
    }
}
</style>
